import { WithAccountId, WithEnterpriseId, WithScope } from '@mews-commander/types';
import { Container, Stack, StackItem } from '@optimus-web/core';
import { ScopeProvider } from '@mews/framework';
import BillingGroupingSelect from '../components/BillingGroupingSelect';
import { ExpandCollapseAll } from '../ExpandCollapseAll';
import { AccountItemAssignmentDialog } from '../ItemAssignmentDialog';
import { TopToolbar } from '../TopToolbar';
import { BillingPageLoadingWrapper } from '../components/BillingPageLoadingWrapper';
import { AccountBillCard } from './components';

type AccountBillingProps = WithScope & WithAccountId & WithEnterpriseId;

export const AccountBilling = ({ scope, accountId, enterpriseId }: AccountBillingProps) => (
    <BillingPageLoadingWrapper scope={scope}>
        <ScopeProvider value={scope}>
            <Container padding={['300', '300', '0', '300']}>
                <Stack distribution="space-between">
                    <StackItem width="220px">
                        <BillingGroupingSelect scope={scope} />
                    </StackItem>
                    <ExpandCollapseAll />
                </Stack>
                <TopToolbar />
                <Container padding={['600', '0']}>
                    <AccountBillCard accountId={accountId} enterpriseId={enterpriseId} />
                </Container>
            </Container>
            <AccountItemAssignmentDialog />
        </ScopeProvider>
    </BillingPageLoadingWrapper>
);
